import { render, staticRenderFns } from "./RelatorioContratoLai.vue?vue&type=template&id=4e009388&"
import script from "./RelatorioContratoLai.vue?vue&type=script&lang=js&"
export * from "./RelatorioContratoLai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports